var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBulk = function SvgBulk(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    fillRule: "evenodd",
    d: "M4 4h9.389c.798 0 1.444.597 1.444 1.333V14h.723c.798 0 1.444-.597 1.444-1.333V3.333C17 2.597 16.354 2 15.556 2H5.444C4.646 2 4 2.597 4 3.333zm8.667 1H3.333C2.597 5 2 5.632 2 6.412v9.176C2 16.368 2.597 17 3.333 17h9.334c.736 0 1.333-.632 1.333-1.412V6.412C14 5.632 13.403 5 12.667 5m-.351 3.178a.61.61 0 0 1 0 .86l-4.857 4.856a.61.61 0 0 1-.86 0l-2.428-2.428a.608.608 0 0 1 .86-.86l2 1.998 4.427-4.426a.61.61 0 0 1 .86 0z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBulk);
export default ForwardRef;